<template>
    <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="total"
        :footer-props="{
            itemsPerPageOptions: [2, 10, 25, 50]
        }"
        :loading="isFetch"
        loading-text="Загрузка данных... Ожидайте"
        @update:options="onOptionsUpdate"
    >
        <template v-slot:[`item.data`]="{ item }">
            <pre>{{ JSON.stringify(item, null, 2) }}</pre>
        </template>
    </v-data-table>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            default: () => []
        },
        total: {
            type: Number,
            default: 0
        },
        isFetch: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            headers: [
                {
                    text: 'JSON Data',
                    value: 'data',
                    sortable: false
                }
            ],
            options: {}
        }
    },
    methods: {
        onOptionsUpdate(options) {
            this.$emit('update:options', {
                limit: options.itemsPerPage,
                offset: (options.page - 1) * options.itemsPerPage
            });
        }
    }
}
</script>

<style scoped>
pre {
    background-color: #f5f5f5;
    padding: 10px;
    border-radius: 4px;
    overflow-x: auto;
    font-size: 12px;
}
</style>